import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/**
 * SWELLの標準スライダーを破壊して、独自のSwiper設定で再構築するハック
 */
export default function hackSwellPickupSlider() {
	// SWELLのピックアップスライダーのラッパーを取得
	const swellSwiperEl = document.querySelector(".p-postSlider__swiper");
	if (!swellSwiperEl) return;

	// SWELLがすでに初期化したSwiperインスタンスがあるかチェック
	if (swellSwiperEl.swiper) {
		// 一度完全に内臓のSwiperを破壊して、HTMLをプレーンな状態に戻す
		swellSwiperEl.swiper.destroy(true, true);
	}

	// SWELLのスライダーを再初期化
	const customSwiper = new Swiper(swellSwiperEl, {
		modules: [Navigation, Pagination, Autoplay],
		loop: true,
		slidesPerView: 1.2,
		centeredSlides: true,
		spaceBetween: 16,
		autoplay: {
			delay: 5000, // 5秒ごとにスライド（ミリ秒指定）
			disableOnInteraction: false, // ユーザーが手動でスワイプしても自動再生を止めない設定
		},
		breakpoints: {
			768: {
				slidesPerView: 2.5,
				spaceBetween: 24,
			},
			1201: {
				slidesPerView: 3.4,
				spaceBetween: 40,
			},
		},
		pagination: {
			el: swellSwiperEl.querySelector(".swiper-pagination") || null, // もしHTML側にドットナビがなければ自動無視される
			clickable: true,
		},
		navigation: {
			nextEl: swellSwiperEl.querySelector(".swiper-button-next"),
			prevEl: swellSwiperEl.querySelector(".swiper-button-prev"),
		},
	});

	// 矢印を画像の中心（高さ半分）に持ってくる計算ロジック（SWELLのクラス名に対応）
	function updateArrowPosition() {
		// SWELLのサムネイル画像ラッパーのクラス名
		const imgWrap = swellSwiperEl.querySelector(".p-postList__thumb");
		const prevArrow = swellSwiperEl.querySelector(".swiper-button-prev");
		const nextArrow = swellSwiperEl.querySelector(".swiper-button-next");

		if (imgWrap && prevArrow && nextArrow) {
			const imgHeight = imgWrap.clientHeight;
			const arrowTop = imgHeight / 2;

			prevArrow.style.top = arrowTop + "px";
			nextArrow.style.top = arrowTop + "px";
		}
	}

	// イベント登録
	window.addEventListener("load", updateArrowPosition);
	window.addEventListener("resize", updateArrowPosition);

	// 即時実行
	updateArrowPosition();

	return customSwiper;
}

// 💡 ドキュメント読み込み完了時に実行（SWELLのJSより確実に後に走らせる）
document.addEventListener("DOMContentLoaded", () => {
	// SWELLの初期化を確実に追い抜くために、ほんの少しだけディレイを入れる
	setTimeout(() => {
		hackSwellPickupSlider();
	}, 100);
});
